<template>
	<DropdownCustom v-if="currentAccountSets" class="app-header-message-vue" placement="bottom-end" className="app-account-sets-dropdown" :toggleIcon="false" ref="messageDropdown">
		<div class="app-header-icon-item">
			{{currentAccountSets.companyName}}
		</div>
		<div slot="content">
			<div class="h-panel">
				<div class="common-list-container">
					<div @click="changeAccountSets(as)" class="common-list-item" :class="{current:as.id == currentAccountSets.id}" v-for="as of myAccountSets" :key="as.id">
						{{as.companyName}}
					</div>
				</div>
			</div>
		</div>
	</DropdownCustom>
</template>
<script>
	import {mapState} from 'vuex';

	export default {
		name: 'AppHeaderAccountSets',
		data() {
			return {
				messageList: []
			};
		},
	methods: {
			changeAccountSets(as) {
				if (as.id != this.currentAccountSets.id) {
					this.$refs.messageDropdown.hide();
					this.$Loading("正在切换，请稍后...");
					this.$api.common.changeAccountSets(as.id).then(() => {
						this.$Message('切换成功！');
						window.location.reload();
					});
				}
			}
		},
		computed: {
			...mapState(['currentAccountSets', 'myAccountSets'])
		}
	};
</script>
<style lang='less'>
	.app-header-message-vue {
		height: 40px;
		width: 220px;
		float: left;
		margin-right: 12px;
		border: 1px solid rgba(166, 179, 203, 0.22);
		border-radius: 14px;
		background: #fff;
		box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

		.h-dropdowncustom-show {
			height: 40px;
			line-height: 40px;
			border-radius: 14px;

			.app-header-icon-item {
				margin-right: 0;
				padding: 0 14px;
				width: 100%;
				height: 40px;
				line-height: 40px;
				font-size: 13px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			&.h-pop-trigger {
				background: #f6f8fc;
			}
		}
	}

	.app-account-sets-dropdown-dropdown-container {
		width: 260px;
		min-height: 180px;
		padding: 8px;
		border-radius: 18px;
		border: 1px solid rgba(166, 179, 203, 0.22);
		box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12);

		.common-list-container {
			.common-list-item {
				cursor: pointer;
				padding: 10px 12px;
				border-radius: 12px;

				&:hover {
					background: #f6f8fc;
				}

				&.current {
					background: #eef4ff;
					color: #3763f4;
				}
			}
		}
	}
</style>
